import { getPublicPara, setH5Config, urlList } from '../../api/api'
import axios from 'axios'
import { baseUrlApi, resCode } from '../../api/common'
import { funCfg, textCfg } from '../../config'

const h5Config = {
  state: {
    h5Config: null
  },
  mutations: {
    H5CONFIG (state, info) {
      if (info) {
        state.h5Config = info
      } else {
        const newConfig = {
          funCfg: funCfg,
          textCfg: textCfg
        }
        state.h5Config = newConfig
      }
    }
  },
  getters: {
    h5Config: state => state.h5Config
  },
  actions: {
    async H5CONFIGACTION ({ commit, state }, force) {
      const defaultH5Config = {
        textCfg: textCfg,
        funCfg: funCfg
      }
      if (!state.h5Config || force) {
        const options = {
          method: 'post',
          url: baseUrlApi + '/' + urlList.getH5Config,
          data: getPublicPara(true),
          json: true
        }
        try {
          const { data } = await axios(options)
          if (data) {
            let h5Config
            if (data.code === resCode.OK) {
              h5Config = {
                textCfg: data.textCfg,
                funCfg: data.funCfg
              }
              setH5Config(h5Config)
              commit('H5CONFIG', h5Config)
            } else if (data.code === resCode.Unauthorized || data.code === resCode.InternalServerError) {
              // 说明没有接口
              h5Config = defaultH5Config
              setH5Config(h5Config)
              commit('H5CONFIG', h5Config)
            }
            return h5Config
          }
        } catch (e) {
          return defaultH5Config
        }
      } else if (state.h5Config) {
        return state.h5Config
      } else {
        return defaultH5Config
      }
    }
  }
}

export default h5Config
